import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, FacebookIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';
import { Logo } from './Logo';
import { navItems } from '../data/navigation';
const socials = [{
  icon: FacebookIcon,
  label: 'Facebook',
  href: '#'
}, {
  icon: InstagramIcon,
  label: 'Instagram',
  href: '#'
}, {
  icon: LinkedinIcon,
  label: 'LinkedIn',
  href: '#'
}];
export function Footer() {
  return <footer className="w-full bg-ardis-green-dark text-white/80" data-id="element-42" data-mp="3ud7ddkscv8gj">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 lg:grid-cols-4 lg:px-8" data-id="element-43" data-mp="387fbm8yvbf9">
        <div className="lg:col-span-1" data-id="element-44" data-mp="3ldu3ir0bkhva">
          <Logo variant="dark" data-id="element-45" data-mp="3qdf3n4r86w9l" />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/60" data-id="element-46" data-mp="3qcdsl0a7m9rv">
            Uw partner voor bevoorrading. Een ruim assortiment
            kwaliteitsproducten voor de beste prijs.
          </p>
          <div className="mt-5 flex gap-3" data-id="element-47" data-mp="2ezbeqczhvybe">
            {socials.map(s => <a key={s.label} href={s.href} aria-label={s.label} className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-ardis-yellow hover:text-ardis-green-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-ardis-yellow" data-id="element-48" data-mp="3l8qv40rs6dpv">
                <s.icon className="h-4 w-4" data-id="element-49" data-mp="830grbvt3sxb" />
              </a>)}
          </div>
        </div>

        <div data-id="element-50" data-mp="3472viclxzwm">
          <h3 className="font-display text-sm font-bold uppercase tracking-wider text-white" data-id="element-51" data-mp="34p9n8wwbwis">
            Navigatie
          </h3>
          <ul className="mt-4 space-y-2.5" data-id="element-52" data-mp="hsacd1puztq6">
            {navItems.map(item => <li key={item.label} data-id="element-53" data-mp="cus3tcfr7gip">
                <a href={item.href} className="text-sm text-white/70 transition-colors hover:text-ardis-yellow" data-id="element-54" data-mp="cvtmo330h7az">
                  {item.label}
                </a>
              </li>)}
          </ul>
        </div>

        <div data-id="element-55" data-mp="two4vw6mvl8d">
          <h3 className="font-display text-sm font-bold uppercase tracking-wider text-white" data-id="element-56" data-mp="tt088o5w6ipf">
            Contact
          </h3>
          <ul className="mt-4 space-y-3 text-sm" data-id="element-57" data-mp="13tkds30g29dg">
            <li className="flex items-start gap-2.5" data-id="element-58" data-mp="13rpsuop6ah9d">
              <MapPinIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-ardis-yellow" data-id="element-59" data-mp="18jr3652s5xwr" />
              <span data-id="element-60" data-mp="1clmbhtj4pbk1">Duinhoekstraat 9, 8660 De Panne, België</span>
            </li>
            <li className="flex items-center gap-2.5" data-id="element-61" data-mp="1cnyr401ez9tx">
              <PhoneIcon className="h-4 w-4 flex-shrink-0 text-ardis-yellow" data-id="element-62" data-mp="1hjnw4iw7dixm" />
              <a href="tel:+32480205930" className="hover:text-ardis-yellow" data-id="element-63" data-mp="1mj8w8wn3zxbx">
                +32 480 20 59 30
              </a>
            </li>
            <li className="flex items-center gap-2.5" data-id="element-64" data-mp="1ri3m2ijhum5j">
              <MailIcon className="h-4 w-4 flex-shrink-0 text-ardis-yellow" data-id="element-65" data-mp="3obx0987kuosr" />
              <a href="mailto:contact@adinter.be" className="hover:text-ardis-yellow" data-id="element-66" data-mp="3ta86l8ynyh68">
                contact@adinter.be
              </a>
            </li>
          </ul>
        </div>

        <div data-id="element-67" data-mp="25ncbk69rca65">
          <h3 className="font-display text-sm font-bold uppercase tracking-wider text-white" data-id="element-68" data-mp="25nls738wx4z6">
            Openingstijden
          </h3>
          <ul className="mt-4 space-y-2.5 text-sm text-white/70" data-id="element-69" data-mp="21kfljuhw1bs6">
            <li className="flex justify-between gap-4" data-id="element-70" data-mp="1wpa2d3fveb7s">
              <span data-id="element-71" data-mp="2tehq8i3yowev">Ma – Vr</span>
              <span data-id="element-72" data-mp="2tcojl2tcmc6v">8.00 – 19.00 uur</span>
            </li>
            <li className="flex justify-between gap-4" data-id="element-73" data-mp="2pcnt2jsz6ajg">
              <span data-id="element-74" data-mp="2pd5vxza57n0c">Zaterdag</span>
              <span data-id="element-75" data-mp="2kdb8y6thnhkk">9.00 – 18.00 uur</span>
            </li>
            <li className="flex justify-between gap-4" data-id="element-76" data-mp="2kbqe0g39hwm6">
              <span data-id="element-77" data-mp="2feq5zzmuqjsf">Zondag</span>
              <span data-id="element-78" data-mp="2fdotdqq6tp8l">Gesloten</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-79" data-mp="18yxn17iapc76">
        <div className="mx-auto max-w-7xl px-4 py-5 text-center text-xs text-white/50 sm:px-6 lg:px-8" data-id="element-80" data-mp="13z1h32q1faoz">
          © 2026 A.D. INTER. Alle rechten voorbehouden.
        </div>
      </div>
    </footer>;
}